/* hs-eslint ignored failing-rules */
/* eslint-disable conversations/no-dynamic-i18n */

'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getAgentId } from 'conversations-message-history/filtered-change-message/operators/filteredChangeMessageGetters';
import { AGENT } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import DashedLabel from '../atoms/DashedLabel';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import FullSenderName from '../senders/components/FullSenderName';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { getDateString as getDate } from 'conversations-message-history/util/labelDateUtils';
import { chooseFilteredChangeMessage } from './operators/chooseFilteredChangeMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const getDateString = message => {
  const timestamp = getTimestamp(message);
  const momentTimestamp = I18n.moment(timestamp);
  return getDate(momentTimestamp);
};
const FilteredChangeMessage = ({
  message,
  senders,
  userId
}) => {
  const senderId = getAgentId(message);
  const senderType = AGENT;
  const asyncSender = findSender(senderId, senderType, senders);
  const isSelfMarker = senderId === userId;
  if (isSenderLoading(asyncSender) && !isSelfMarker) {
    return /*#__PURE__*/_jsx(DashedLabel, {
      transparent: true,
      children: /*#__PURE__*/_jsx(SkeletonText, {
        "data-test-id": "skeleton-text",
        width: 200
      })
    });
  }
  const dateString = getDateString(message);
  const marker = !isSelfMarker && /*#__PURE__*/_jsx(FullSenderName, {
    sender: getData(asyncSender)
  });
  const {
    i18nKey,
    options
  } = chooseFilteredChangeMessage({
    message,
    isSelfMarker,
    dateString,
    marker
  });
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey,
      options: options
    })
  });
};
FilteredChangeMessage.displayName = 'FilteredChangeMessage';
FilteredChangeMessage.propTypes = {
  message: RecordPropType('FilteredChangeMessage').isRequired,
  senders: SenderMap.isRequired,
  userId: PropTypes.number.isRequired
};
export default FilteredChangeMessage;